import { apiClient } from '../shared/api-client';

const authentificationRepository = {
    async requestToMagicLink(body) {
        try {
            const data = await apiClient.post({
                url: 'auth/email',
                body,
                isCheckAccessToken: false
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    async signIn(token) {
        try {
            await apiClient.post({
                url: 'auth/email/sign-in',
                body: {},
                isCheckAccessToken: false,
                token
            });

            return true;
        } catch (error) {
            throw Error(error?.message || 'Sign in fail request');
        }
    },

    async signInBySubscription(subscriptionId) {
        try {
            await apiClient.post({
                url: 'auth/subscription',
                body: {subscriptionId},
                isCheckAccessToken: false
            });

            return true;
        } catch (error) {
            throw Error(error?.message || 'Sign in by subscription fail request');
        }
    },

    async signOut() {
        try {
            await apiClient.post({
                url: 'auth/logout',
                body: {}
            });

            return true;
        } catch (error) {
            throw Error(error?.message || 'Sign out fail request');
        }
    }
};
  
export {
    authentificationRepository
};